import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";

import "./styles/navBar.css";

const SECTIONS = [
	{ name: "home", label: "Home", selector: ".homepage-container" },
	{ name: "about", label: "About", selector: ".about-container" },
	{ name: "projects", label: "Projects", selector: ".projects-container" },
	{
		name: "experience",
		label: "Experience",
		selector: ".experience-container",
	},
	{ name: "contact", label: "Contact", selector: ".contact-container" },
];

const NavBar = () => {
	const [active, setActive] = useState("home");

	useEffect(() => {
		const updateActive = () => {
			const scrollY = window.scrollY;
			const viewportHeight = window.innerHeight;
			const docHeight = document.documentElement.scrollHeight;

			// When the page is scrolled to the bottom, the last section can
			// never reach the top of the viewport, so force it active.
			if (scrollY + viewportHeight >= docHeight - 2) {
				setActive(SECTIONS[SECTIONS.length - 1].name);
				return;
			}

			const line = scrollY + viewportHeight * 0.35;
			let current = SECTIONS[0].name;

			for (const section of SECTIONS) {
				const el = document.querySelector(section.selector);
				if (!el) continue;
				const top = el.getBoundingClientRect().top + scrollY;
				if (top <= line) current = section.name;
			}

			setActive(current);
		};

		updateActive();
		window.addEventListener("scroll", updateActive, { passive: true });
		window.addEventListener("resize", updateActive);
		return () => {
			window.removeEventListener("scroll", updateActive);
			window.removeEventListener("resize", updateActive);
		};
	}, []);

	return (
		<React.Fragment>
			<div className="nav-container">
				<nav className="navbar">
					<div className="nav-background">
						<ul className="nav-list">
							{SECTIONS.map((section) => (
								<li key={section.name}>
									<Link
										to={section.name}
										smooth={true}
										duration={500}
										className={`nav-item${
											active === section.name
												? " active"
												: ""
										}`}
									>
										{section.label}
									</Link>
								</li>
							))}
						</ul>
					</div>
				</nav>
			</div>
		</React.Fragment>
	);
};

export default NavBar;
